import { gql } from '@apollo/client';

export const NoteFragments = {
  fragments: {
    Quantite: gql`
      fragment Quantite on Note {
        qtevente
        qtepro
        qtequiz
        qterebond
        qteca
      }
    `,
    Moyenne: gql`
      fragment Moyenne on Note {
        cavente
        nbvente
        venterebond
        pro
        moyennegenerale
        quiz
      }
    `,
    LeaderBoardUser: gql`
      fragment UserLeaderBoard on Note {
        user {
          data {
            id
            attributes {
              firstname
              lastname
              ville
              avatar {
                data {
                  id
                  attributes {
                    media {
                      data {
                        id
                        attributes {
                          url
                        }
                      }
                    }
                  }
                }
              }
              notes {
                data {
                  id
                  attributes {
                    moyennegenerale
                  }
                }
              }
            }
          }
        }
      }
    `,
    EleveDashBoardProf: gql`
      fragment EleveDashBoardProf on UsersPermissionsUser {
        username
        email
        firstname
        lastname
        ville
        mdp
        shop
        role {
          data {
            attributes {
              name
            }
          }
        }
        quiztonotes {
          data {
            attributes {
              note
              createdAt
              quiz {
                data {
                  id
                }
              }
            }
          }
        }
        avatar {
          data {
            id
            attributes {
              media {
                data {
                  id
                  attributes {
                    url
                  }
                }
              }
            }
          }
        }
        notes {
          data {
            id
            attributes {
              createdAt
              updatedAt
              nbvente
            }
          }
        }
      }
    `,
    Rank: gql`
      fragment Rank on Rank {
        rank
        moyennegenerale
        username
        firstname
        lastname
        ville
        avatar {
          media {
            url
          }
        }
        elId
      }
    `,
    ChallengeNote: gql`
      fragment ChallengeNote on Note {
        cavente
        quiz
        nbvente
        venterebond
        pro
        moyennegenerale
      }
    `,
    QuizToNote: gql`
      fragment NoteDesQuiz on Quiztonote {
        note
        quiz {
          data {
            id
            attributes {
              name
              debut
              fin
            }
          }
        }
      }
    `
  }
};
